import { render, staticRenderFns } from "./ConfirmAccount.vue?vue&type=template&id=1ab2af58&"
import script from "./ConfirmAccount.vue?vue&type=script&lang=ts&"
export * from "./ConfirmAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports